import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import {EmployeeRoleLevel} from 'client';
import {Avatar} from 'components/DSYS/Avatar';
import {PersonHoverCard} from 'components/DSYS/HoverCard';
import {ButtonLink} from 'components/DSYS/Link';
import {ROUTE_PATHS} from 'constant';

export const OwnerLink = ({owner}: {owner: EmployeeRoleLevel}) => (
  <Box>
    <PersonHoverCard ldap={owner.ldap} name={owner.name} role={owner.role}>
      <ButtonLink
        to={`${ROUTE_PATHS.PROFILE.replace(':userid', owner.ldap)}`}
        variant="borderless"
        size="small"
        style={{display: 'inline-block', marginLeft: -5}}
        withIconStart={<Avatar user={owner} size="xsmall" />}
      >
        <Text size="small" style={{marginLeft: 2}}>
          {owner.name}
        </Text>
      </ButtonLink>
    </PersonHoverCard>
  </Box>
);
